import React from "react";
import { Drawer, Spin, Form, Input, Select, DatePicker } from "antd";
import { UserOutlined, IdcardOutlined, PhoneOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/es/form";
import { Employee } from "../../../Types";
import { RecordStatus } from "../../../Enums";
import {
  DRAWER_FORM_WIDTH,
  drawerFooter,
  drawerTitle,
} from "../../../components";

const { Option } = Select;

interface EmployeeFormProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  onSubmit: () => void;
  editingEmployee: Employee | null;
  form: FormInstance;
}

export const EmployeeForm: React.FC<EmployeeFormProps> = ({
  open,
  onClose,
  loading,
  onSubmit,
  editingEmployee,
  form,
}) => {
  return (
    <Drawer
      title={drawerTitle(
        editingEmployee ? "Edit Employee" : "Add New Employee",
      )}
      open={open}
      onClose={onClose}
      width={DRAWER_FORM_WIDTH}
      footer={drawerFooter({
        actions: [
          { label: "Cancel", onClick: onClose },
          {
            label: editingEmployee ? "Save Changes" : "Create Employee",
            type: "primary",
            loading,
            onClick: onSubmit,
          },
        ],
      })}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <div className="grid grid-cols-2 gap-x-3">
            <Form.Item
              label="First name"
              name="first_name"
              rules={[{ required: true, message: "First name is required." }]}
            >
              <Input
                prefix={<UserOutlined className="text-gray-400" />}
                placeholder="John"
              />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="last_name"
              rules={[{ required: true, message: "Last name is required." }]}
            >
              <Input placeholder="Doe" />
            </Form.Item>
          </div>

          <Form.Item label="Designation" name="designation">
            <Input placeholder="e.g. Cashier, Manager, Technician..." />
          </Form.Item>

          <Form.Item label="Hire Date" name="hire_date">
            <DatePicker className="w-full" format="YYYY-MM-DD" />
          </Form.Item>

          <Form.Item label="NIC" name="nic">
            <Input
              prefix={<IdcardOutlined className="text-gray-400" />}
              placeholder="National ID number"
            />
          </Form.Item>

          <Form.Item label="Phone" name="phone">
            <Input
              prefix={<PhoneOutlined className="text-gray-400" />}
              placeholder="+94 7X XXX XXXX"
            />
          </Form.Item>

          <Form.Item label="Address" name="address">
            <Input.TextArea
              rows={2}
              placeholder="Street, City"
              style={{ resize: "none" }}
            />
          </Form.Item>

          <Form.Item label="Status" name="status">
            <Select>
              <Option value={RecordStatus.ACTIVE}>
                <span className="text-green-600 font-medium">Active</span>
              </Option>
              <Option value={RecordStatus.INACTIVE}>
                <span className="text-gray-400 font-medium">Inactive</span>
              </Option>
            </Select>
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
};
